import {
  CentralEmail,
  NotificationRecipient,
  NotificationRecipientsGetError,
  RequestError,
} from '@vi-iot/client';

export interface NotificationsState {
  notifications: boolean;
  email: string;
  loading: boolean;
  loaded: boolean;
  centralMailState: CrudDataState<CentralEmail>;
  notificationRecipientsState: CrudDataState<NotificationRecipient[]>;
}

export interface CrudDataState<T> {
  data: T;
  loading: boolean;
  loaded: boolean;
  dataPresent: boolean;
  errorGET?: RequestError<NotificationRecipientsGetError>;
  errorPOST?: RequestError;
  errorPUT?: RequestError;
  errorDELETE?: RequestError;
}

export enum CentralMailStatus {
  Default,
  Loading,
  Loaded,
  Error,
}

export enum NotificationRecipientsStatus {
  Default,
  Loading,
  Loaded,
  LoadedNoRecipients,
  ErrorCentralEmailRequired,
  Error,
}
